import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SocialSharing } from '@ionic-native/social-sharing';
import { AppState } from '../../config/state';
import { Platform } from 'ionic-angular';
import { ApiProvider } from '../api/api';
/*
  Generated class for the SocialMediaSharingProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SocialMediaSharingProvider {
  windowNav: any;
  constructor(public http: HttpClient, private socialSharing: SocialSharing, private state: AppState, private platform: Platform, private api: ApiProvider) {
  }

  shareOnTwitter(){
    this.socialSharing.shareViaEmail('the body of my message', 'wee subject', ['ray@communico.co']).then((res) => {
      // console.log('yay', res);
    }).catch((err)=> {
      console.log('fail to share', err);
    })
  }

  shareOptions(event){
    this.windowNav = window.navigator;
    let options = {
      message: event.title, // not supported on some apps (Facebook, Instagram)
      subject: event.title, // fi. for email
      files: null, // an array of filenames either locally or remotely
      url: `https://${this.state.client.keyword}.libnet.info/event/${event.eventId}`
    };

    if (this.platform.is("cordova")){
      this.socialSharing.shareWithOptions(options).then( (res)=> {
      }).catch((err)=> {
        console.log('fail to share', err);
      })
    } else {
      if (this.windowNav && this.windowNav.share){
        this.windowNav['share']({
          title: event.title,
          text: event.shortDescription,
          url: `https://${this.state.client.keyword}.libnet.info/event/${event.eventId}`
        }).then( (res)=> {
        }).catch((err)=> {
          console.log('fail to share', err);
        });
      } else {
        console.log('error with window', this.windowNav);
      };
    };
  }

  async getTweets(url, count){
    let tweets: any = false;
    if (tweets && tweets.length > 0) {

    }

    const queryTweets = `{
      getTwitterFeed(url:"${url}", count:${count}){
        created_at, text, id
      }
    }`

    tweets = await this.api.query(queryTweets);

    return tweets.getTwitterFeed || null;
  }

}



// WEBPACK FOOTER //
// ./src/providers/social-media-sharing/social-media-sharing.ts